import {identity} from "lodash";
import {IShare} from "../../types";
import {FB_ID} from "modules/utils/constants";

const FB_SHARE_URL = process.env.REACT_APP_FB_SHARE_URL || "";
const protocol = window.location.protocol;

/**
 * in order to reduce the size of the string for sharing
 */
const last_four_number = -4;
const getTimestamp = () => Date.now().toString().substr(last_four_number);

const getEncodedJson = (object: any) => btoa(JSON.stringify(object));
const getLinkForShare = (object: any, type: string) =>
	`${protocol}${FB_SHARE_URL}${type}/${getEncodedJson(object)}`;

export const share = (data: IShare) => {
	if (data.sc === "tw") {
		shareTwitter(data);
	}

	if (data.sc === "fb") {
		shareFB(data);
	}
};

export const shareFB = (data: IShare) => {
	const {sc, league_id, section, round_id, user_id} = data;

	const object: any = {
		sc,
		t: getTimestamp(),
	};

	if (league_id) {
		object.league_id = league_id;
	}

	if (round_id) {
		object.round = round_id;
	}

	if (user_id) {
		object.user_id = user_id;
	}

	const link = getLinkForShare(object, section);

	if (window.FB && FB_ID) {
		window.FB.ui(
			{
				method: "share",
				display: "popup",
				href: link,
			},
			identity
		);
		return;
	}

	const winWidth = 626;
	const winHeight = 436;
	const winTop = window.screen.height / 2 - winHeight / 2;
	const winLeft = window.screen.width / 2 - winWidth / 2;

	window.open(
		`https://www.facebook.com/sharer/sharer.php?display=popup&u=${link}`,
		"_blank",
		`top=${winTop},left=${winLeft},width=${winWidth}, height=${winHeight},toolbar=0,status=0,scrollbars=no,resizable=1`
	);
};

export const shareTwitter = (data: IShare) => {
	const {sc, league_id, section, round_id, user_id} = data;
	const object: any = {
		sc,
		t: getTimestamp(),
	};

	if (league_id) {
		object.league_id = league_id;
	}

	if (round_id) {
		object.round = round_id;
	}

	if (user_id) {
		object.user_id = user_id;
	}

	if (league_id) {
		object.league_id = league_id;
	}
	const href = getLinkForShare(object, section);
	window.open(
		"https://twitter.com/share?url=" +
			encodeURIComponent(href) +
			"&text=" +
			encodeURIComponent(data.message),
		"twitter-share-dialog",
		"width=626,height=436"
	);
};

/**
 * Fallback for browsers without the async clipboard API.
 *
 * Returns whether the copy succeeded - `document.execCommand("copy")` reports
 * failure by returning `false`, it does not throw.
 */
const legacyCopy = (text: string): boolean => {
	const active_element = document.activeElement as HTMLElement | null;
	const selection = document.getSelection();
	const saved_range =
		selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

	// A detached, `display: none` or `visibility: hidden` element cannot be
	// selected, so the field has to stay in the layout while we copy from it.
	const el = document.createElement("textarea");
	el.value = text;
	el.setAttribute("aria-hidden", "true");
	el.style.cssText =
		"position:fixed;top:0;left:0;width:1px;height:1px;padding:0;" +
		"border:none;outline:none;box-shadow:none;background:transparent;" +
		// 16px keeps iOS Safari from zooming when the field takes focus.
		"opacity:0;font-size:16px;";

	document.body.appendChild(el);

	let copied = false;

	try {
		// iOS Safari refuses to copy from a readonly or non-editable field.
		el.contentEditable = "true";
		el.readOnly = false;
		el.focus();
		el.setSelectionRange(0, text.length);

		copied = document.execCommand("copy");
	} catch (e) {
		copied = false;
	} finally {
		document.body.removeChild(el);

		// Give the page back the selection and focus we took from it.
		if (selection && saved_range) {
			selection.removeAllRanges();
			selection.addRange(saved_range);
		}

		if (active_element && typeof active_element.focus === "function") {
			active_element.focus();
		}
	}

	return copied;
};

export const copyToClipboard = async (text: string): Promise<void> => {
	if (!text) {
		throw new Error("copyToClipboard: nothing to copy");
	}

	if (navigator.clipboard && navigator.clipboard.writeText) {
		try {
			await navigator.clipboard.writeText(text);
			return;
		} catch (e) {
			// Denied permission, an insecure origin or a lost user gesture -
			// try the legacy path before giving up.
		}
	}

	if (!legacyCopy(text)) {
		throw new Error("copyToClipboard: the browser rejected the copy");
	}
};
